export default __webpack_public_path__ + "static/media/mei-goticed.85c85415.mp3";